/**
 * Chess-specific create game form - color selection
 */

import { useState } from "react";
import type { CreateGameFormProps } from "../../game-registry";

type ChessColor = "WHITE" | "BLACK";

export function ChessCreateGameForm({ onConfigChange }: CreateGameFormProps) {
  const [preferredColor, setPreferredColor] = useState<ChessColor>("WHITE");

  const handleChange = (color: ChessColor) => {
    setPreferredColor(color);
    onConfigChange({ preferredColor: color });
  };

  return (
    <div className="flex items-center gap-3">
      <label htmlFor="color-select" className="text-sm">
        색상 선택:
      </label>
      <select
        id="color-select"
        data-testid="color-select"
        value={preferredColor}
        onChange={(e) => handleChange(e.target.value as ChessColor)}
        className="rounded-md border border-border-primary px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-accent-blue"
      >
        <option value="WHITE">백</option>
        <option value="BLACK">흑</option>
      </select>
    </div>
  );
}
